import * as React from 'react'
import { Linking } from 'react-native'

import MenuLayout from './layout/MenuLayout'
import FormLayout from './layout/FormLayout'
import SimpleAlert from '@components/modal/SimpleAlert'

import useReducer from '@store/useReducer'
import useBreakpoint from '@utils/useBreakpoints'
import useI18n from '@i18n/useI18n'
import * as UserStore from '@store/user/user'

import { reset } from '@store/store'
import config from '../../../config'

const DELETE_ACCOUNT_SUBJECT = 'Demande de suppression de compte Viper v2'
const DELETE_ACCOUNT_BODY = ' demande une suppression de compte.'

const AccountScreen = () => {
  const i18n = useI18n()
  const [, bp] = useBreakpoint()

  const user = useReducer(UserStore.store, (s) => s.user)

  if (!user) {
    return null
  }

  const logout = () => {
    reset()
  }

  const confirmAction = (actionKey: string, onConfirm: () => void) => {
    SimpleAlert.open({
      title: i18n.t('common.confirm'),
      description: i18n.t(`screens.account.confirm.${actionKey}`),
      buttons: [
        {
          label: i18n.t('common.cancel'),
          color: 'cancel',
          onClick: () => {
            SimpleAlert.close()
          },
        },
        {
          label: i18n.t('common.validate'),
          onClick: () => {
            onConfirm()
            SimpleAlert.close()
          },
        },
      ],
    })
  }

  const onLogout = () => confirmAction('logout', logout)

  const onDeleteAccount = () =>
    confirmAction('deleteAccount', () =>
      Linking.openURL(
        `mailto:${config.DELETE_ACCOUNT_MAIL}?subject=${DELETE_ACCOUNT_SUBJECT}&body=${
          user.email + DELETE_ACCOUNT_BODY
        }`
      )
    )

  return bp === 'phone' ? (
    <MenuLayout onLogout={onLogout} onDeleteAccount={onDeleteAccount} />
  ) : (
    <FormLayout onLogout={onLogout} onDeleteAccount={onDeleteAccount} />
  )
}

export default AccountScreen
